
import React from "react";
import { CheckCircle, MessageSquare, Shield, Map, FileText, AlertTriangle } from "lucide-react";

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container">
        <div className="mx-auto mb-16 max-w-2xl text-center">
          <h2 className="mb-4 text-3xl font-bold text-navy-800 md:text-4xl">
            Why Citizens Should Report Crimes
          </h2>
          <p className="text-lg text-gray-600">
            Your participation in crime reporting helps create a more transparent, accountable, and safer community for everyone.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          <div className="rounded-lg bg-white p-6 shadow-sm">
            <CheckCircle className="mb-4 h-10 w-10 text-safeteal-500" />
            <h3 className="mb-2 text-xl font-bold text-navy-800">Increased Safety</h3>
            <p className="text-gray-600">
              When citizens report crimes, law enforcement can better allocate resources to high-risk areas, leading to safer neighborhoods.
            </p>
          </div>

          <div className="rounded-lg bg-white p-6 shadow-sm">
            <MessageSquare className="mb-4 h-10 w-10 text-safeteal-500" />
            <h3 className="mb-2 text-xl font-bold text-navy-800">Community Voice</h3>
            <p className="text-gray-600">
              Your reports give you a voice in community safety priorities and help authorities understand local concerns.
            </p>
          </div>

          <div className="rounded-lg bg-white p-6 shadow-sm">
            <Shield className="mb-4 h-10 w-10 text-safeteal-500" />
            <h3 className="mb-2 text-xl font-bold text-navy-800">Crime Prevention</h3>
            <p className="text-gray-600">
              Timely reporting helps prevent future crimes by identifying patterns and enabling early intervention strategies.
            </p>
          </div>

          <div className="rounded-lg bg-white p-6 shadow-sm">
            <Map className="mb-4 h-10 w-10 text-safeteal-500" />
            <h3 className="mb-2 text-xl font-bold text-navy-800">Improved Response</h3>
            <p className="text-gray-600">
              Accurate citizen reports enable faster, more targeted responses from law enforcement agencies.
            </p>
          </div>

          <div className="rounded-lg bg-white p-6 shadow-sm">
            <FileText className="mb-4 h-10 w-10 text-safeteal-500" />
            <h3 className="mb-2 text-xl font-bold text-navy-800">Better Documentation</h3>
            <p className="text-gray-600">
              Documented reports help create comprehensive records for insurance claims and legal proceedings.
            </p>
          </div>

          <div className="rounded-lg bg-white p-6 shadow-sm">
            <AlertTriangle className="mb-4 h-10 w-10 text-safeteal-500" />
            <h3 className="mb-2 text-xl font-bold text-navy-800">Early Warning System</h3>
            <p className="text-gray-600">
              Community reporting serves as an early warning system for emerging crime trends in your neighborhood.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
